function SkillGallery() {
  return (
    <section className='mt-16'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6' id='skills'>
        {/* Divider */}
        <span className='block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        <h3 className='text-2xl font-black text-text-main mb-3 leading-tighter'>What our members say.</h3>
      </div>
      <div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Brings together like-minded individuals</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Very strong network</mark>"
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Impressive founders</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Makes the journey a little less excruciating.</mark>"
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Accelerated my network growth</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Powerful mastermind framework</mark>
            ."
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Share journeys and solve problems together</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Only founders get founders</mark>
            ."
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Lots of incredible people</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>It's like group therapy</mark>
            ."
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>

          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Mastermind is really powerful</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'> Well organised</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Good facilitator</mark>
            ."
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
        <div className='flex gap-2 md:gap-3 justify-center mb-2 md:mb-3'>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-l-none'></div>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "Never knew I needed a <mark className='bg-highlight-yellow'>mastermind group</mark>
            ."
          </p>
          <p className='shrink-0 border-highlight-darkEggshell shadow-highlight-eggshell border-2 px-3 p-1 md:p-4 rounded-md text-sm md:text-2xl font-bold text-text-main'>
            "<mark className='bg-highlight-yellow'>Highly recommended</mark>
            ."
          </p>
          <div className='w-full shrink bg-highlight-eggshell p-4 rounded-md rounded-r-none'></div>
        </div>
      </div>
    </section>
  );
}

export default SkillGallery;
